import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const RunnoSearchParamsSchema = z
  .object({
    key: z.string().optional(),
    year: z.number().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type RunnoSearchParams = z.infer<typeof RunnoSearchParamsSchema>

export const RunnoSearchResultModelSchema = z.object({
  id: z.number(),
  key: z.string(),
  year: z.number(),
  month: z.number().nullable(),
  prefix: z.string(),
  currentNumber: z.number(),
  padding: z.number(),
  suffix: z.string(),
})

export type RunnoSearchResultModel = z.infer<
  typeof RunnoSearchResultModelSchema
>

export const RunnoSearchResultSchema = z
  .object({
    data: z.array(RunnoSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type RunnoSearchResult = z.infer<typeof RunnoSearchResultSchema>
